import { i18n, type Messages } from '@lingui/core';

export { i18n };
export type Locale = 'he' | 'en';
export const LOCALES: Locale[] = ['he', 'en'];
export const RTL_LOCALES = new Set(['he', 'ar']);

export function isRtl(locale: string): boolean {
  return RTL_LOCALES.has(locale.split('-')[0] ?? locale);
}
export function dirFor(locale: string): 'rtl' | 'ltr' {
  return isRtl(locale) ? 'rtl' : 'ltr';
}

/** Tenant default: Hebrew for .co.il hostnames, English otherwise (Studio spec §3.1). */
export function defaultLocaleFor(hostname: string | undefined | null): Locale {
  return hostname && /\.co\.il$/i.test(hostname) ? 'he' : 'en';
}

const loaders: Record<Locale, () => Promise<{ messages: Messages }>> = {
  he: () => import('../locales/he/messages.po'),
  en: () => import('../locales/en/messages.po'),
};

/** Load a catalogue and activate it; also sets <html lang dir>. */
export async function activateLocale(locale: Locale): Promise<void> {
  const { messages } = await loaders[locale]();
  i18n.load(locale, messages);
  i18n.activate(locale);
  if (typeof document !== 'undefined') {
    document.documentElement.lang = locale;
    document.documentElement.dir = dirFor(locale);
  }
}

export * from './format';
